export const tradingProfile = {
  en: {
    "trading_profile.total_trades": "Total Trades",
    "trading_profile.win_rate": "Win Rate",
    "trading_profile.trading_volume": "Trading Volume",
    "trading_profile.realized_pnl": "Realized PnL",
    "trading_profile.win": "Win",
    "trading_profile.loss": "Loss",

    "trading_profile.productivity_statistics": "Productivity Statistics",

    "trading_profile.pnl": "PnL",
    "trading_profile.average_pnl": "Average PnL",
    "trading_profile.average_pnl_percent": "Average PnL%",
    "trading_profile.positions": "Positions",
    "trading_profile.profit_loss_ratio": "Profit and Loss Ratio",
    "trading_profile.risk_reward": "Risk and Reward",

    "trading_profile.total_pnl": "Total PnL",
    "trading_profile.total_profit": "Total Profit",
    "trading_profile.total_loss": "Total Loss",

    "trading_profile.avg_pnl": "Avg. PnL",
    "trading_profile.avg_profit": "Avg. Profit",
    "trading_profile.avg_loss": "Avg. Loss",

    "trading_profile.avg_pnl_percent": "Avg. PnL%",
    "trading_profile.avg_pnl_percent_profit":
      "Avg. PnL% of Profitable Positions",
    "trading_profile.avg_pnl_percent_loss": "Avg. PnL% of Losing Positions",

    "trading_profile.holding_time": "Holding Time",
    "trading_profile.avg_holding_time": "Avg. Holding Time",
    "trading_profile.avg_profitable_time": "Avg. Profitable Positions Time",
    "trading_profile.avg_losing_time": "Avg. Losing Positions Time",

    "trading_profile.closed_positions": "Closed Positions",
    "trading_profile.profitable_positions": "Profitable Positions",
    "trading_profile.losing_positions": "Losing Positions",
    "trading_profile.breakeven_positions": "Breakeven Positions",

    "trading_profile.profit_ratio": "Profit Ratio",
    "trading_profile.loss_ratio": "Loss Ratio",
    "trading_profile.longest_profit_streak": "Longest Profit Streak",
    "trading_profile.longest_loss_streak": "Longest Loss Streak",

    "trading_profile.profit_factor": "Profit Factor",
    "trading_profile.expected_value": "Expected Value",
    "trading_profile.risk_reward_ratio": "Risk/Reward Ratio",

    "trading_profile.pnl_chart_no_activity":
      "No trading activity during this period",
    "trading_profile.pnl_chart_no_activity_hint":
      "Try changing the selected date range",
    "trading_profile.pnl_chart_tooltip_time": "Time",
    "trading_profile.pnl_chart_tooltip_pnl": "Pnl",
    "trading_profile.pnl_chart_title": "PnL Chart",

    "trading_profile.trading_calendar": "Trading Calendar",
    "trading_profile.average_daily_pnl": "Average Daily PnL",
    "trading_profile.average_monthly_pnl": "Average Monthly PnL",
    "trading_profile.profitable_days": "Profitable Days",
    "trading_profile.profitable_months": "Profitable Months",
    "trading_profile.losing_days": "Losing Days",
    "trading_profile.losing_months": "Losing Months",
    "trading_profile.best_day": "Best Day",
    "trading_profile.best_month": "Best Month",
    "trading_profile.daily_pnl": "Daily PnL",
    "trading_profile.monthly_pnl": "Monthly PnL",
    "trading_profile.failed_load_calendar": "Failed to load trading calendar",
  },

  ru: {
    "trading_profile.total_trades": "Всего сделок",
    "trading_profile.win_rate": "Процент побед",
    "trading_profile.trading_volume": "Объём торговли",
    "trading_profile.realized_pnl": "Реализованный PnL",
    "trading_profile.win": "Победа",
    "trading_profile.loss": "Поражение",

    "trading_profile.productivity_statistics": "Статистика продуктивности",

    "trading_profile.pnl": "PnL",
    "trading_profile.average_pnl": "Средний PnL",
    "trading_profile.average_pnl_percent": "Средний PnL%",

    "trading_profile.positions": "Позиции",
    "trading_profile.profit_loss_ratio": "Коэффициент прибыли и убытков",
    "trading_profile.risk_reward": "Риск и награда",

    "trading_profile.total_pnl": "Общий PnL",
    "trading_profile.total_profit": "Общая прибыль",
    "trading_profile.total_loss": "Общий убыток",

    "trading_profile.avg_pnl": "Сред. PnL",
    "trading_profile.avg_profit": "Сред. прибыль",
    "trading_profile.avg_loss": "Сред. убыток",

    "trading_profile.avg_pnl_percent": "Сред. PnL%",
    "trading_profile.avg_pnl_percent_profit": "Сред. PnL% прибыльных позиций",
    "trading_profile.avg_pnl_percent_loss": "Сред. PnL% убыточных позиций",

    "trading_profile.holding_time": "Время удержания",
    "trading_profile.avg_holding_time": "Сред. время удержания",
    "trading_profile.avg_profitable_time": "Сред. время прибыльных позиций",
    "trading_profile.avg_losing_time": "Сред. время убыточных позиций",

    "trading_profile.closed_positions": "Кол-во закрытых позиций",
    "trading_profile.profitable_positions": "Кол-во прибыльных позиций",
    "trading_profile.losing_positions": "Кол-во убыточных позиций",
    "trading_profile.breakeven_positions": "Кол-во безубыточных позиций",

    "trading_profile.profit_ratio": "Коэффициент прибыли",
    "trading_profile.loss_ratio": "Коэффициент убытков",
    "trading_profile.longest_profit_streak": "Самый длинный прибыльный период",
    "trading_profile.longest_loss_streak": "Самый длинный убыточный период",

    "trading_profile.profit_factor": "Фактор прибыли",
    "trading_profile.expected_value": "Ожидаемая стоимость",
    "trading_profile.risk_reward_ratio": "Соотношение риск/награда",

    "trading_profile.pnl_chart_no_activity":
      "За этот период не было торговой активности",
    "trading_profile.pnl_chart_no_activity_hint":
      "Попробуйте изменить выбранный диапазон дат",
    "trading_profile.pnl_chart_tooltip_time": "Время",
    "trading_profile.pnl_chart_tooltip_pnl": "Pnl",
    "trading_profile.pnl_chart_title": "График PnL",

    "trading_profile.trading_calendar": "Торговый календарь",
    "trading_profile.average_daily_pnl": "Средний дневной PnL",
    "trading_profile.average_monthly_pnl": "Средний месячный PnL",
    "trading_profile.profitable_days": "Прибыльные дни",
    "trading_profile.profitable_months": "Прибыльные месяцы",
    "trading_profile.losing_days": "Убыточные дни",
    "trading_profile.losing_months": "Убыточные месяцы",
    "trading_profile.best_day": "Лучший день",
    "trading_profile.best_month": "Лучший месяц",
    "trading_profile.daily_pnl": "Дневной PnL",
    "trading_profile.monthly_pnl": "Месячный PnL",
    "trading_profile.failed_load_calendar":
      "Не удалось загрузить торговый календарь",
  },

  es: {
    "trading_profile.total_trades": "Total de operaciones",
    "trading_profile.win_rate": "Porcentaje de éxito",
    "trading_profile.trading_volume": "Volumen de trading",
    "trading_profile.realized_pnl": "PnL realizado",
    "trading_profile.win": "Ganancia",
    "trading_profile.loss": "Pérdida",

    "trading_profile.productivity_statistics": "Estadísticas de productividad",

    "trading_profile.pnl": "PnL",
    "trading_profile.average_pnl": "PnL promedio",
    "trading_profile.average_pnl_percent": "PnL% promedio",

    "trading_profile.positions": "Posiciones",
    "trading_profile.profit_loss_ratio": "Relación ganancias y pérdidas",
    "trading_profile.risk_reward": "Riesgo y recompensa",

    "trading_profile.total_pnl": "PnL total",
    "trading_profile.total_profit": "Ganancia total",
    "trading_profile.total_loss": "Pérdida total",

    "trading_profile.avg_pnl": "PnL prom.",
    "trading_profile.avg_profit": "Ganancia prom.",
    "trading_profile.avg_loss": "Pérdida prom.",

    "trading_profile.holding_time": "Tiempo de retención",
    "trading_profile.avg_holding_time": "Tiempo promedio de retención",
    "trading_profile.avg_profitable_time":
      "Tiempo promedio de posiciones rentables",
    "trading_profile.avg_losing_time":
      "Tiempo promedio de posiciones perdedoras",

    "trading_profile.closed_positions": "Posiciones cerradas",
    "trading_profile.profitable_positions": "Posiciones rentables",
    "trading_profile.losing_positions": "Posiciones perdedoras",
    "trading_profile.breakeven_positions": "Posiciones sin pérdidas",

    "trading_profile.profit_factor": "Factor de beneficio",
    "trading_profile.expected_value": "Valor esperado",
    "trading_profile.risk_reward_ratio": "Relación riesgo/recompensa",

    "trading_profile.pnl_chart_no_activity":
      "No hubo actividad de trading en este período",
    "trading_profile.pnl_chart_no_activity_hint":
      "Prueba cambiar el rango de fechas seleccionado",
    "trading_profile.pnl_chart_tooltip_time": "Hora",
    "trading_profile.pnl_chart_tooltip_pnl": "Pnl",
    "trading_profile.pnl_chart_title": "Gráfico de PnL",

    "trading_profile.trading_calendar": "Calendario de trading",
    "trading_profile.average_daily_pnl": "PnL diario promedio",
    "trading_profile.average_monthly_pnl": "PnL mensual promedio",
    "trading_profile.profitable_days": "Días rentables",
    "trading_profile.profitable_months": "Meses rentables",
    "trading_profile.losing_days": "Días con pérdidas",
    "trading_profile.losing_months": "Meses con pérdidas",
    "trading_profile.best_day": "Mejor día",
    "trading_profile.best_month": "Mejor mes",
    "trading_profile.daily_pnl": "PnL diario",
    "trading_profile.monthly_pnl": "PnL mensual",
    "trading_profile.failed_load_calendar":
      "No se pudo cargar el calendario de trading",
  },

  ua: {
    "trading_profile.total_trades": "Всього угод",
    "trading_profile.win_rate": "Відсоток перемог",
    "trading_profile.trading_volume": "Торговий обсяг",
    "trading_profile.realized_pnl": "Реалізований PnL",
    "trading_profile.win": "Перемога",
    "trading_profile.loss": "Поразка",

    "trading_profile.productivity_statistics": "Статистика продуктивності",

    "trading_profile.pnl": "PnL",
    "trading_profile.average_pnl": "Середній PnL",
    "trading_profile.average_pnl_percent": "Середній PnL%",

    "trading_profile.positions": "Позиції",
    "trading_profile.profit_loss_ratio": "Коефіцієнт прибутків і збитків",
    "trading_profile.risk_reward": "Ризик і винагорода",

    "trading_profile.total_pnl": "Загальна сума PnL",
    "trading_profile.total_profit": "Загальний прибуток",
    "trading_profile.total_loss": "Загальний збиток",

    "trading_profile.avg_pnl": "Сер. PnL",
    "trading_profile.avg_profit": "Сер. прибуток",
    "trading_profile.avg_loss": "Сер. збиток",

    "trading_profile.avg_pnl_percent": "Сер. PnL%",
    "trading_profile.avg_pnl_percent_profit": "Сер. PnL% прибуткових позицій",
    "trading_profile.avg_pnl_percent_loss": "Сер. PnL% збиткових позицій",

    "trading_profile.holding_time": "Час утримання",
    "trading_profile.avg_holding_time": "Сер. час утримання",
    "trading_profile.avg_profitable_time": "Сер. час прибуткових позицій",
    "trading_profile.avg_losing_time": "Сер. час утрим. збиткових позицій",

    "trading_profile.closed_positions": "К-сть закритих позицій",
    "trading_profile.profitable_positions": "К-сть прибуткових позицій",
    "trading_profile.losing_positions": "К-сть збиткових позицій",
    "trading_profile.breakeven_positions": "К-сть беззбиткових позицій",

    "trading_profile.profit_ratio": "Коефіцієнт прибутків",
    "trading_profile.loss_ratio": "Коефіцієнт збитків",
    "trading_profile.longest_profit_streak": "Найдовший прибутковий період",
    "trading_profile.longest_loss_streak": "Найдовший збитковий період",

    "trading_profile.profit_factor": "Фактор прибутку",
    "trading_profile.expected_value": "Очікувана вартість",
    "trading_profile.risk_reward_ratio": "Співвідношення ризику/винагороди",

    "trading_profile.pnl_chart_no_activity":
      "За цей період не було торгової активності",
    "trading_profile.pnl_chart_no_activity_hint":
      "Спробуйте змінити обраний діапазон дат",
    "trading_profile.pnl_chart_tooltip_time": "Час",
    "trading_profile.pnl_chart_tooltip_pnl": "Pnl",
    "trading_profile.pnl_chart_title": "Графік PnL",

    "trading_profile.trading_calendar": "Календар торгівлі",
    "trading_profile.average_daily_pnl": "Середній денний PnL",
    "trading_profile.average_monthly_pnl": "Середній місячний PnL",
    "trading_profile.profitable_days": "Прибуткові дні",
    "trading_profile.profitable_months": "Прибуткові місяці",
    "trading_profile.losing_days": "Збиткові дні",
    "trading_profile.losing_months": "Збиткові місяці",
    "trading_profile.best_day": "Найкращий день",
    "trading_profile.best_month": "Найкращий місяць",
    "trading_profile.daily_pnl": "Денний PnL",
    "trading_profile.monthly_pnl": "Місячний PnL",
    "trading_profile.failed_load_calendar":
      "Не вдалося завантажити торговий календар",
  },
};

export default tradingProfile;
